const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
let storeRef = null;

export const setApiStore = (store) => {
  storeRef = store;
};

const getApiUrl = (path) => {
  if (!path) return API_BASE_URL;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${API_BASE_URL}${path}`;
};

const handleUnauthorized = () => {
  if (storeRef?.dispatch) {
    storeRef.dispatch({ type: 'auth/logout' });
  }
  if (typeof window !== 'undefined') {
    window.location.replace('/login');
  }
};

const buildHeaders = (extra = {}, skipAuth = false) => {
  const headers = {
    ...extra
  };
  if (!skipAuth) {
    const token = storeRef?.getState?.()?.auth?.accessToken;
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
  }
  return headers;
};

const isOkResultCode = (code) => {
  if (code === undefined || code === null || code === '') return true;
  const numeric = Number(code);
  return numeric === 200 || numeric === 0;
};

const extractErrorMessage = (data, fallback) => {
  if (data && typeof data === 'object') {
    return data.resultDesc || data.resultMessage || data.message || fallback;
  }
  return fallback;
};

export const apiFetch = async (path, options = {}) => {
  const {
    headers,
    skipAuth = false,
    parseAs = 'json',
    handleResultCode = true,
    autoLogout = true,
    ...rest
  } = options;
  const response = await fetch(getApiUrl(path), {
    ...rest,
    headers: buildHeaders(headers, skipAuth)
  });

  if (response.status === 401) {
    if (autoLogout) {
      handleUnauthorized();
    }
    throw new Error('Unauthorized');
  }

  if (parseAs === 'raw') {
    return response;
  }

  if (parseAs === 'blob') {
    if (!response.ok) {
      throw new Error(response.statusText || 'Request failed');
    }
    return response;
  }

  const contentType = response.headers.get('content-type') || '';
  let data;
  if (parseAs === 'text' || !contentType.includes('application/json')) {
    data = await response.text();
  } else {
    data = await response.json();
  }

  if (!response.ok) {
    const message = extractErrorMessage(data, response.statusText || 'Request failed');
    throw new Error(message);
  }

  if (handleResultCode && data && typeof data === 'object' && !isOkResultCode(data.resultCode)) {
    if (Number(data.resultCode) === 401 && autoLogout) {
      handleUnauthorized();
    }
    throw new Error(extractErrorMessage(data, 'Request failed'));
  }

  return data;
};
